var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIRpe01({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1266_22132)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.5574 6.26304C28.3914 4.25556 31.0799 2.94828 33.1998 4.62493C35.7597 6.64848 36.1966 11.7106 35.9332 15.0028C35.7372 17.46 35.2683 19.7758 34.3368 22.0339C32.657 26.1067 29.5221 29.2255 25.3818 30.8058C20.4193 32.7041 14.8208 32.6623 9.9322 30.5713C4.55535 28.2715 1.49112 23.4793 0.427957 17.8487C-0.0602642 15.2566 -0.175895 12.6966 0.318749 10.1142C0.633523 8.46646 1.12817 6.9215 2.09819 5.59495C3.19026 4.10138 4.95042 3.49432 6.70416 4.09175C9.30908 5.01037 11.1046 7.67632 12.4375 10.2106C13.1892 8.36368 14.0692 6.65169 15.4568 5.24485C16.8926 3.78982 19.0478 3.64849 20.5799 5.00395C22.1409 6.29516 23.0788 8.25768 23.9396 10.1977C24.6623 8.73948 25.4782 7.44505 26.5574 6.26304Z",
    fill: "#46AF83"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.0874 19.6185C25.0381 21.3305 24.3925 24.0542 22.8604 24.2148C22.2886 24.2726 21.6623 23.9803 21.3218 23.3733C20.7084 22.2876 20.7308 20.7105 21.3218 19.6153C21.6302 19.0435 22.157 18.7769 22.658 18.7544C23.2201 18.7287 23.7597 19.0307 24.0874 19.6185Z",
    fill: "#231815"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6739 19.5414C15.6889 21.1827 15.0946 24.051 13.4758 24.202C12.8687 24.2598 12.2649 23.8904 11.9405 23.2737C10.9737 21.4397 11.7381 18.8636 13.1707 18.7544C13.7649 18.7095 14.3109 18.9568 14.6739 19.5414Z",
    fill: "#231815"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5704 25.9493C20.5704 26.8326 19.4205 27.5489 17.9976 27.5489C16.5747 27.5489 15.4248 26.8326 15.4248 25.9493",
    stroke: "#231815",
    strokeWidth: 1.28479,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1266_22132"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIRpe01);
export default __webpack_public_path__ + "static/media/i_RPE_01.e36287e89546893be6f7fb3737f57e0b.svg";
export { ForwardRef as ReactComponent };